import React, { useCallback } from 'react'
import cn from 'classnames'

import KeyboardHandler from 'components/Lists/KeyboardHandler'
import KeyboardNavigator from 'components/KeyboardNavigator'
import Scroller from 'components/Scroller'

import { getLength, isEmpty } from 'util/arrays'
import { Divider } from 'shared/ui'
import NoCannedReplies from './NoCannedReplies'

import Header from './Header'
import List from './List'
import styles from './styles.less'

const DropdownMenu = ({
  autoScroll,
  className,
  focusedItem,
  focusedItemIcon,
  hideModal,
  items = [],
  emptyPlaceholder,
  isLoadingItems,
  hasLoadedItems,
  onBackClick,
  onItemFocus,
  onItemSelect,
  searchTerm,
}) => {
  const focusedIndex = items.indexOf(focusedItem)
  const handleSelect = useCallback(
    index => {
      onItemSelect(items[index])
    },
    [items, onItemSelect]
  )
  const handleFocus = useCallback(
    index => {
      onItemFocus(items[index])
    },
    [items, onItemFocus]
  )
  const isEmptyResults = hasLoadedItems && isEmpty(items)
  const isEmptyAccount = isEmptyResults && searchTerm === '' && !isLoadingItems

  return (
    <div className={cn(className, styles.DropdownMenu)}>
      <KeyboardNavigator.Focus />
      <KeyboardHandler
        focusedIndex={focusedIndex}
        count={getLength(items)}
        pageSize={8}
        onEnter={handleSelect}
        onTab={handleSelect}
        onUp={handleFocus}
        onDown={handleFocus}
        onPageDown={handleFocus}
        onPageUp={handleFocus}
        onLeft={onBackClick}
        onEsc={hideModal}
      />
      <Header className="canned-header" />

      <Divider className={cn('grui mt-4', styles.divider)} />

      <Scroller className="scrollingList">
        {isEmptyResults && (
          <NoCannedReplies
            onClick={hideModal}
            isEmptyAccount={isEmptyAccount}
          />
        )}
        {!isEmptyResults && (
          <List
            items={items}
            emptyPlaceholder={emptyPlaceholder}
            autoScroll={autoScroll}
            focusedItem={focusedItem}
            focusedItemIcon={focusedItemIcon}
            itemClassName={styles.reply}
            onItemClick={onItemSelect}
            onItemFocus={onItemFocus}
          />
        )}
      </Scroller>
    </div>
  )
}

export default DropdownMenu
